module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Light.8bdcb11a.ttf";